import axiosInstance from '../Config/AxiosInstance';

const NTA_PREFIX = `/clinic/god/nta`;

// Active Dx Groups
export const getActiveDxGroups = () =>
  axiosInstance.get(`${NTA_PREFIX}/active-dx-groups`);

export const createActiveDxGroup = data =>
  axiosInstance.post(`${NTA_PREFIX}/active-dx-groups`, data);

export const updateActiveDxGroup = (id, data) =>
  axiosInstance.put(`${NTA_PREFIX}/active-dx-groups`, data, { params: { id } });

// NTA Comorbidities I8000
export const getComorbidities = () =>
  axiosInstance.get(`${NTA_PREFIX}/comorbidities`);

export const createComorbidity = data =>
  axiosInstance.post(`${NTA_PREFIX}/comorbidities`, data);

export const updateComorbidity = (id, data) =>
  axiosInstance.put(`${NTA_PREFIX}/comorbidities`, data, { params: { id } });

// ICD10 to Active Dx
export const getIcd10ToActiveDx = () =>
  axiosInstance.get(`${NTA_PREFIX}/icd10-to-active-dx`);

export const createIcd10ToActiveDx = data =>
  axiosInstance.post(`${NTA_PREFIX}/icd10-to-active-dx`, data);

export const updateIcd10ToActiveDx = (id, data) =>
  axiosInstance.put(`${NTA_PREFIX}/icd10-to-active-dx`, data, { params: { id } });

// ICD10 to I8000
export const getIcd10ToI8000 = () =>
  axiosInstance.get(`${NTA_PREFIX}/icd10-to-i8000`);

export const createIcd10ToI8000 = data =>
  axiosInstance.post(`${NTA_PREFIX}/icd10-to-i8000`, data);

export const updateIcd10ToI8000 = (id, data) =>
  axiosInstance.put(`${NTA_PREFIX}/icd10-to-i8000`, data, { params: { id } });

// ICD10 Max NTA Lookup
export const getIcd10MaxLookup = () =>
  axiosInstance.get(`${NTA_PREFIX}/icd10-max-lookup`);

export const createIcd10MaxLookup = data =>
  axiosInstance.post(`${NTA_PREFIX}/icd10-max-lookup`, data);

export const updateIcd10MaxLookup = (id, data) =>
  axiosInstance.put(`${NTA_PREFIX}/icd10-max-lookup`, data, { params: { id } });
